import { numberFormat } from "highcharts";
import { CreateSeries_ActualDays } from "../../../../shared/scripts/graphing/graphing-functions";
import { ForecastGraphDataPoint } from "../../forecasts/scripts/forecasts.entities";
import { ChartSetup } from "./enrollment.chart-controller";
import { Participant } from "./enrollment.entities";
import { EnrollmentLookup } from "./enrollment.lookup";

var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/lollipop')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/dumbbell')(Highcharts);

export class ChartLine {

    constructor() { }

    UpdateChart(chartSetup: ChartSetup): void {

        Highcharts.chart('enrollment-chart', {
            chart: {
                backgroundColor: 'white',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'top',
                        x: -10,
                        y: 0
                    },
                    relativeTo: 'chart'
                }
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'datetime',
                //max: maxDate,
                showLastLabel: true,
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%e %b %Y', this.value);
                    }
                }
            },
            yAxis: {
                //max: maxEnrollment,
                title: {
                    text: 'Number of Participants'
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',');
                    }
                }
            },
            plotOptions: {
                line: {
                    stickyTracking: false,
                    findNearestPointBy: 'xy',
                    marker: {
                        enabled: !chartSetup.moreThan15Points
                    }
                },
                lollipop: {
                    marker: {
                        enabled: true
                    }
                }
            },
            tooltip: {
                xDateFormat: '%e %b %Y',
                shared: false
            },
            legend: {
                enabled: chartSetup.showLegend,
                //symbolWidth: 0
            },
            series: chartSetup.series
        });
    }
}